import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "GeolocationListPage" */
	'pages/vehicle/Geolocation/GeolocationListPage'));

export default [{ component, exact: true, path: '/geolocations' }];